import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromI18n from './i18n.reducers';

export const reducers = fromI18n.reducer;

export const selectI18NState = createFeatureSelector<any>('i18n');

export const getUserLang = createSelector(selectI18NState, fromI18n.getUserLang);

export const getUserCurrency = createSelector(selectI18NState, fromI18n.getUserCurrency);

export const getUserCountry = createSelector(selectI18NState, fromI18n.getUserCountry);

export const getDirectShippingEligibility = createSelector(selectI18NState, fromI18n.getDirectShipping);
